function updateHeaderLoginBtn() {
  const sidebar = document.querySelector('header-sidebar');
  if (!sidebar) return;

  const shadowRoot = sidebar.shadowRoot;
  if (!shadowRoot) return;

  const btn = shadowRoot.getElementById('kp-account');
  const txt = shadowRoot.getElementById('kwik-pass-text');
  const userToken = localStorage.getItem('KWIKSESSIONTOKEN');

  if (btn && txt) {
    if (userToken) {
      txt.textContent = (typeof window.themeStrings !== "undefined" && window.themeStrings.account_label) ? window.themeStrings.account_label : "Account";
      btn.classList.remove('kwik-pass-login');
      btn.classList.add('kwik-pass-account');
      btn.onclick = function (e) {
        e.preventDefault();
        window.location.href = '/account#wishlist';
        return false;
      };
    } else {
      txt.textContent = "Log in";
      btn.classList.remove('kwik-pass-account');
      btn.classList.add('kwik-pass-login');
      btn.onclick = function (e) {
        e.preventDefault();
        if (typeof kpHandleLogin === "function") {
          kpHandleLogin('/account#wishlist');
        } else if (typeof handleShopifyLogin === "function") {
          handleShopifyLogin(e, "/account#wishlist");
        } else {
          window.location.href = '/account/login';
        }
        return false;
      };
    }
  }
}

window.addEventListener('user-loggedin', function(event) {
  const { token } = event?.detail || {};
  if (token) {
    updateHeaderLoginBtn();
  }
});
document.addEventListener('DOMContentLoaded', updateHeaderLoginBtn);

function addNoUnderlineToShadowButton() {
  const sidebar = document.querySelector('header-sidebar');
  if (!sidebar) return;
  const shadowRoot = sidebar.shadowRoot;
  if (!shadowRoot) return;

  if (!shadowRoot.getElementById('no-underline-style')) {
    const style = document.createElement('style');
    style.id = 'no-underline-style';
    style.textContent = `
      #kp-account, #kp-account span {
        text-decoration: none !important;
        box-shadow: none !important;
        cursor: pointer;
      }
    `;
    shadowRoot.appendChild(style);
  }
}

document.addEventListener('DOMContentLoaded', addNoUnderlineToShadowButton);
window.addEventListener('user-loggedin', addNoUnderlineToShadowButton);
;
(function () {
  function initSidebarAccordions(root) {
    root = root || document;
    const sidebar = root.querySelector('#sidebar-menu') || root.querySelector('header-sidebar');
    if (!sidebar) return;
    if (sidebar.__saadaaAccordionBound) return;
    sidebar.__saadaaAccordionBound = true;

    function setIcon(section, stateOpen) {
      const btn = section.querySelector('.saadaa-accordion-title');
      if (!btn) return;
      const icon = btn.querySelector('.icon');
      if (!icon) return;
      icon.textContent = stateOpen ? '−' : '+';
    }

    function closeMainAccordions(exceptSection) {
      sidebar.querySelectorAll('.saadaa-accordion-section[data-main]').forEach((s) => {
        if (exceptSection && s === exceptSection) return;
        s.classList.remove('open');
        setIcon(s, false);
      });
    }

    function normalizeIcons() {
      sidebar.querySelectorAll('.saadaa-accordion-section').forEach((section) => {
        const content = section.querySelector('.saadaa-accordion-content');
        const btn = section.querySelector('.saadaa-accordion-title');
        if (!btn || !content) return;
        setIcon(section, section.classList.contains('open'));
      });
    }

    function ensureDefaultOpen() {
      const defaultMains = sidebar.querySelectorAll('.saadaa-accordion-section[data-main][data-default-open="true"]');
      if (defaultMains.length > 0) {
        closeMainAccordions(defaultMains[0]);
        defaultMains[0].classList.add('open');
        setIcon(defaultMains[0], true);
      } else {
        const firstMain = sidebar.querySelector('.saadaa-accordion-section[data-main]');
        if (firstMain) {
          closeMainAccordions(firstMain);
          firstMain.classList.add('open');
          setIcon(firstMain, true);
        }
      }
    }

    sidebar.addEventListener('click', function (e) {
      const btn = e.target.closest('.saadaa-accordion-title');
      if (!btn) return;
      const section = btn.closest('.saadaa-accordion-section');
      if (!section) return;
      const content = section.querySelector('.saadaa-accordion-content');
      if (!content) return; 

      e.preventDefault();
      e.stopPropagation();

      const isMain = section.hasAttribute('data-main');
      const isOpen = section.classList.contains('open');

      if (isMain) {
        closeMainAccordions();
        if (!isOpen) {
          section.classList.add('open');
          setIcon(section, true);
        } else {
          section.classList.remove('open');
          setIcon(section, false);
        }
      } else {
        section.classList.toggle('open');
        setIcon(section, section.classList.contains('open'));
      }
    }, { passive: false });

    normalizeIcons();
    ensureDefaultOpen();
    normalizeIcons();
  }

  /* 2026-10-01 speed: the observer watched every DOM change on the page forever (≈1 s of main thread on app-heavy
     pages). Now: at most one check per frame, and it disconnects as soon as the sidebar's accordions are bound. */
  document.addEventListener('DOMContentLoaded', function () {
    initSidebarAccordions(document);
    function bound() { var sb = document.querySelector('#sidebar-menu') || document.querySelector('header-sidebar'); return !!(sb && sb.__saadaaAccordionBound); }
    if (bound()) return;
    let queued = false;
    const obs = new MutationObserver(() => {
      if (queued) return; queued = true;
      requestAnimationFrame(() => { queued = false; initSidebarAccordions(document); if (bound()) obs.disconnect(); });
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
;
(function(){
  function updateNavIcons() {
    document.querySelectorAll('.fixed_nav--link').forEach(link => {
      var img = link.querySelector('img');
      if (img) {
        if (link.classList.contains('active_url')) {
          if (img.dataset.imgBlack) img.src = img.dataset.imgBlack;
        } else {
          if (img.dataset.imgGray) img.src = img.dataset.imgGray;
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    const links = document.querySelectorAll('.fixed_nav--link');
    links.forEach(link => {
      link.addEventListener('click', function() {
        links.forEach(l => l.classList.remove('active_url'));
        this.classList.add('active_url');
        sessionStorage.setItem('activeNavTab', this.getAttribute('data-nav'));
        updateNavIcons();
      });
    });

    const saved = sessionStorage.getItem('activeNavTab');
    let setActive = false;
    if (saved) {
      links.forEach(link => {
        if (link.getAttribute('data-nav') === saved) {
          link.classList.add('active_url');
          setActive = true;
        }
      });
    }
    if (!setActive) {
      const path = window.location.pathname;
      links.forEach(link => {
        if (link.getAttribute('href') === path) {
          link.classList.add('active_url');
          setActive = true;
        }
      });
    }
    if (!setActive && links[0]) {
      links[0].classList.add('active_url');
    }
    updateNavIcons();
  });

  function setBottomAccountLogin() {
    var label = (typeof window.themeStrings !== "undefined" && window.themeStrings.account_label) ? window.themeStrings.account_label : "Account";
    var el = document.getElementById('kp-bottom-account');
    var txt = document.getElementById('kp-bottom-account-text');
    if (el && txt) {
      txt.textContent = label;
      el.classList.remove('kwik-pass-login');
      el.classList.add('kwik-pass-account');
      el.onclick = function(e){
        e.preventDefault();
        window.location.href = '/account#wishlist';
        return false;
      };
    }
  }

  function setBottomAccountLogout() {
    var el = document.getElementById('kp-bottom-account');
    var txt = document.getElementById('kp-bottom-account-text');
    if (el && txt) {
      txt.textContent = "Log in";
      el.classList.remove('kwik-pass-account');
      el.classList.add('kwik-pass-login');
      el.onclick = function(e){
        e.preventDefault();
        if (typeof kpHandleLogin === "function") {
          kpHandleLogin('/account#wishlist');
        } else if (typeof handleShopifyLogin === "function") {
          handleShopifyLogin(e, "/account#wishlist");
        } else {
          window.location.href = '/account/login';
        }
        return false;
      };
    }
  }

  function setupBottomAccountBtn(){
    var userToken = localStorage.getItem('KWIKSESSIONTOKEN');
    if (userToken) {
      setBottomAccountLogin();
    } else {
      setBottomAccountLogout();
    }
  }

  window.addEventListener('user-loggedin', function(event) {
    const { token } = event?.detail || {};
    if (token) {
      setBottomAccountLogin();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    setupBottomAccountBtn();
  });

  document.addEventListener('DOMContentLoaded', function() {
    var bottomMenuTrigger = document.getElementById('mobile-bottom-menu-trigger');
    if (bottomMenuTrigger) {
      bottomMenuTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        document.querySelectorAll('.fixed_nav--link').forEach(l => l.classList.remove('active_url'));
        this.classList.add('active_url');
        sessionStorage.setItem('activeNavTab', this.getAttribute('data-nav'));
        if (typeof updateNavIcons === 'function') updateNavIcons();

        var sidebarOpener = document.querySelector('button[aria-controls="sidebar-menu"]');
        if (sidebarOpener) {
          sidebarOpener.click();
        }
      });
    }

    var sidebarMenu = document.getElementById('sidebar-menu') || document.querySelector('.drawer, .mobile-drawer, .Sidebar, .sidebar, .mobile-menu, .menu-drawer');
    var bottomNav = document.querySelector('.fixed_nav_mobile');
    
    if (sidebarMenu && bottomNav) {
      var observer = new MutationObserver(function() {
        var cs = window.getComputedStyle(sidebarMenu);
        var isOpen = sidebarMenu.classList.contains('opened') ||
                     sidebarMenu.classList.contains('is-open') ||
                     sidebarMenu.classList.contains('active') ||
                     sidebarMenu.getAttribute('aria-hidden') === 'false' ||
                     (cs.display === 'block' && sidebarMenu.offsetWidth > 0) ||
                     (cs.transform && cs.transform !== 'none' && cs.transform !== '');
        if (isOpen) {
          bottomNav.classList.add('hide');
        } else {
          bottomNav.classList.remove('hide');
        }
      });
      observer.observe(sidebarMenu, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden', 'style']
      });

      var cs0 = window.getComputedStyle(sidebarMenu);
      var isOpen0 = sidebarMenu.classList.contains('opened') ||
                   sidebarMenu.classList.contains('is-open') ||
                   sidebarMenu.classList.contains('active') ||
                   sidebarMenu.getAttribute('aria-hidden') === 'false' ||
                   (cs0.display === 'block' && sidebarMenu.offsetWidth > 0) ||
                   (cs0.transform && cs0.transform !== 'none' && cs0.transform !== '');
      if (isOpen0) {
        bottomNav.classList.add('hide');
      }
    }
  });
})();
;
document.addEventListener('DOMContentLoaded', function(){
    var slider   = document.getElementById('offersSlider');
    var closeBtn = slider.querySelector('.offer-slider__close');
    var moreBtn  = document.querySelector('.offer-bar__more');
    var discountBtn = document.getElementById('bottom-nav-discount');
    var header   = document.querySelector('.header');
    var annc     = document.querySelector('.announcement-bar');
    var continueBtn = document.getElementById('offerContinueBtn');
    var pageScrollY = 0;

    function hideHeader(){ if(header) header.style.display='none'; if(annc) annc.style.display='none'; }
    function showHeader(){ if(header) header.style.display=''; if(annc) annc.style.display=''; }

    function openOffers(){
      pageScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('noscroll');
      document.body.style.top = '-' + pageScrollY + 'px';
      slider.classList.add('open');
      slider.setAttribute('aria-hidden','false');
      slider.removeAttribute('inert');
      hideHeader();
      document.getElementById('discount-dot')?.classList.add('is-hidden');
    }

    function closeOffers(){
      slider.classList.remove('open');
      slider.setAttribute('aria-hidden','true');
      slider.setAttribute('inert','');
      showHeader();
      document.body.classList.remove('noscroll');
      document.body.style.top = '';
      window.scrollTo(0, pageScrollY); 
    }

    if(moreBtn){ moreBtn.addEventListener('click', function(e){ e.preventDefault(); openOffers(); }); }
    if(discountBtn){ 
      discountBtn.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelectorAll('.fixed_nav--link').forEach(l => l.classList.remove('active_url'));
        this.classList.add('active_url');
        sessionStorage.setItem('activeNavTab', this.getAttribute('data-nav'));
        openOffers();
      });
    }

    if(closeBtn){ closeBtn.addEventListener('click', closeOffers); }
    if(continueBtn){ continueBtn.addEventListener('click', function(){ closeOffers(); }); }

    slider.querySelectorAll('.copy-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        var code = btn.closest('.offer-item')?.dataset.code;
        if(!code) return;
        navigator.clipboard.writeText(code).then(function(){
          btn.style.opacity='0.6';
          setTimeout(function(){ btn.style.opacity='1'; },800);
        });
      });
    });
  });

  document.addEventListener('DOMContentLoaded', function(){
    var footerToggle = document.getElementById('footerToggle');
    var note = document.getElementById('offerNote');
    if(footerToggle && note){
      footerToggle.addEventListener('click', function(){
        note.style.display = (note.style.display === 'block') ? 'none' : 'block';
      });
    }
  });
